"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rasterGenerator = exports.computeRasterBounds = void 0;
const GeoTIFF = __importStar(require("geotiff"));
const proj4_1 = __importDefault(require("proj4"));
const discrete_range_raster_1 = require("./discrete-range-raster");
const flat_or_discrete_range_raster_1 = require("./flat-or-discrete-range-raster");
const equal_count_raster_1 = require("./equal-count-raster");
const equal_count_by_sign_raster_1 = require("./equal-count-by-sign-raster");
const unique_value_raster_1 = require("./unique-value-raster");
const unique_value_tiff_mapping_raster_1 = require("./unique-value-tiff-mapping-raster");
const raster_generator_constants_1 = require("./raster-generator.constants");
__exportStar(require("./raster-generator.constants"), exports);
const convertFromEPSG3857 = (coords) => {
    const proj = (0, proj4_1.default)("GOOGLE", "WGS84");
    return coords.map(proj.forward);
};
const computeRasterBounds = (bounds) => {
    const [xMin, yMin, xMax, yMax] = bounds;
    const wgsCorners = convertFromEPSG3857([
        [xMin, yMax],
        [xMax, yMax],
        [xMin, yMin],
        [xMax, yMin],
    ]);
    return {
        north: Math.max(...wgsCorners.map((x) => x[1])),
        south: Math.min(...wgsCorners.map((x) => x[1])),
        east: Math.max(...wgsCorners.map((x) => x[0])),
        west: Math.min(...wgsCorners.map((x) => x[0])),
    };
};
exports.computeRasterBounds = computeRasterBounds;
/**
 * Used to generate the raster using the provided strategy and coloranges.
 */
exports.rasterGenerator = {
    /**
     * Async function to generate the raster data and bounds with the provided geotiff blob
     *
     * @param blob - { Blob } GeoTiff blob
     * @returns { data: RasterData, bounds: RasterBounds } - raster data and bounds
     */
    rasterDataFromBlob: (blob) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const tiff = yield GeoTIFF.fromBlob(blob);
            const tiffImage = yield tiff.getImage();
            const data = yield tiffImage.readRasters();
            const bounds = (0, exports.computeRasterBounds)(tiffImage.getBoundingBox());
            return { data, bounds };
        }
        catch (err) {
            console.error(err);
            throw err;
        }
    }),
    /**
     * Async function to generate the raster usign the provided geotiff blob
     *
     * @param blob - { Blob } GeoTiff blob
     * @param strategy - { RasterGenerationStrategy } binning strategy to create buckets
     * @param colorRange - {Array<string>} ColorRange from granular/gds-ux-components,
     * @param options - { RasterGenerationStrategyOptions } options related to selected strategy
     */
    fromBlob: (blob, strategy, colorRange = [], options = {}, tiffMapping = {}) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const tiff = yield GeoTIFF.fromBlob(blob);
            const tiffImage = yield tiff.getImage();
            const data = yield tiffImage.readRasters();
            const bounds = (0, exports.computeRasterBounds)(tiffImage.getBoundingBox());
            switch (strategy) {
                case raster_generator_constants_1.RasterGenerationStrategy.UNIQUE_VALUE:
                    return new unique_value_raster_1.UniqueValueRaster(data, bounds, colorRange, options);
                case raster_generator_constants_1.RasterGenerationStrategy.UNIQUE_VALUE_BY_TIFF_MAPPING:
                    return new unique_value_tiff_mapping_raster_1.UniqueValueByTiffMappingRaster(data, bounds, colorRange, tiffMapping, options);
                case raster_generator_constants_1.RasterGenerationStrategy.DISCRETE_RANGE:
                    return new discrete_range_raster_1.DiscreteRangeRaster(data, bounds, colorRange, options);
                case raster_generator_constants_1.RasterGenerationStrategy.FLAT_OR_DISCRETE_RANGE:
                    return new flat_or_discrete_range_raster_1.FlatOrDiscreteRangeRaster(data, bounds, colorRange, options);
                case raster_generator_constants_1.RasterGenerationStrategy.EQUAL_COUNT_BY_SIGN:
                    return new equal_count_by_sign_raster_1.EqualCountBySignRaster(data, bounds, colorRange, options);
                case raster_generator_constants_1.RasterGenerationStrategy.EQUAL_COUNT:
                default:
                    return new equal_count_raster_1.EqualCountRaster(data, bounds, colorRange, options);
            }
        }
        catch (err) {
            console.error(err);
            throw err;
        }
    }),
};
